import { noop } from 'lodash-es';
import { Dispatch, SetStateAction, createContext, useContext, useState } from 'react';
import { AdminStore } from 'services/api/admin';

const map: Record<'ALL' | 'LOCAL' | 'CROSS', 0 | 1 | 2> = {
  ALL: 0,
  LOCAL: 1,
  CROSS: 2,
};

const StoreLimitContext = createContext<{
  storeType: 0 | 1 | 2;
  storeScopes: General.StoreScope[];
  internalItemId?: string[];
  initialStoreScopes?: General.StoreScope[];
  sideStore: AdminStore | undefined;
  setSideStore: Dispatch<SetStateAction<AdminStore | undefined>>;
}>({
  storeType: 0,
  storeScopes: [],
  internalItemId: [] as string[],
  sideStore: undefined,
  setSideStore: noop,
});

export const StoreTypeContextProvider = (props: {
  value: {
    storeType: keyof typeof map;
    storeScopes: General.StoreScope[];
    internalItemId?: string[];
    initialStoreScopes?: General.StoreScope[];
  };
  children: any;
}) => {
  const { value, children } = props;
  const { storeType = 'ALL', storeScopes = [], internalItemId, initialStoreScopes } = value;
  const [sideStore, setSideStore] = useState<AdminStore>();
  return (
    <StoreLimitContext.Provider
      value={{
        storeType: map[storeType],
        storeScopes: storeScopes,
        internalItemId,
        initialStoreScopes,
        sideStore,
        setSideStore,
      }}
    >
      {children}
    </StoreLimitContext.Provider>
  );
};

export const useStoreLimitContext = () => {
  return useContext(StoreLimitContext);
};

export const ConfigContext = createContext<{
  skuSelectDisabled: boolean;
  excludeSpuIds: string[];
  inSupplementKnowledge?: boolean;
}>({
  skuSelectDisabled: false,
  excludeSpuIds: [] as string[],
});
